import { useRef, useEffect, useState, useCallback } from "react";
import {
  useSearchParams,
  useNavigate,
} from "react-router-dom";
import { centroid, polygon } from "@turf/turf";
import { MapType, GovType, SelectedLayersType } from "../../../types/dataTypes";
import { Popup, LngLatLike } from "maplibre-gl";

import { searchParamsObj, toSlug } from "../../../utils/dataHandler";
import {
  mapCorrectLayerOrder,
  mapVisibilityVisible,
  mapVisibilityNone,
  mapRemoveLayerSource,
} from "../../../utils/mapDataHandler";
import {
  LAYER_IDS,
  MAP_BOUNDS,
  MAP_PADDING,
  LAYER_ORDER_ARRAY,
} from "../../../utils/mapConsts";
import { COLORS } from "../../../utils/consts";
import { getGeoJsonByName } from "../../../services/getGeojsonData.service";

type GovLayerProps = {
  map: MapType;
  mapLoaded: boolean;
  setGovData: Function;
  setGovAdm1: Function;
};

function GovLayer({ map, mapLoaded,  setGovData, setGovAdm1 }: GovLayerProps) {  
  const mapCurrent = map.current;
  const { GOVS, GOVS_LINE, SELECTED_GOV } = LAYER_IDS;
  

  useEffect(() => {
    if (!mapLoaded || !mapCurrent) return;

      // Fetch and add the GOVS data layer
      getGeoJsonByName(LAYER_IDS.GOVS).then((res) => {
        if (res.statusCode === 500) {
          console.error("500 Error: data not available");
          return;
        }      
        setGovData(res);

      // Remove existing layers and sources before adding new data
      mapRemoveLayerSource(mapCurrent, [GOVS]);

        //add the govs layer as source
        mapCurrent.addSource(GOVS, {
          type: "geojson",
          data: res,
          generateId: true,
          attribution: `Boundaries: <a href="https://data.humdata.org/dataset/geoboundaries-admin-boundaries-for-algeria">geoboundaries</a> <a href="https://data.humdata.org/faqs/licenses">CC BY-IGO</a>`,
        });

        // Add the GOVS layer and make it visible always
        mapCurrent.addLayer({
          id: GOVS,
          type: "line",
          source: GOVS,
          layout: { visibility: "visible" },
          paint: {
            "line-color": COLORS.MAP.SELECTED_GOV,
            "line-width": 2,
          },
        });
      });

      // Fetch and add the GOVS admin1 data layer including the districts
      getGeoJsonByName(LAYER_IDS.GOVS_LINE).then((res) => {
        if (res.statusCode === 500) {
          console.error("500 Error: data not available");
          return;
        }      
        setGovAdm1(res);

        // Remove existing layers and sources before adding new data
        mapRemoveLayerSource(mapCurrent, [GOVS_LINE]);

        //add the admin1 layer as source
        mapCurrent.addSource(GOVS_LINE, {
          type: "geojson",
          data: res,
          generateId: true,
          attribution: `Boundaries: <a href="https://data.humdata.org/dataset/geoboundaries-admin-boundaries-for-algeria">geoboundaries</a> <a href="https://data.humdata.org/faqs/licenses">CC BY-IGO</a>`,
        });

        // Add the admin1 layer and make it invisible on the first load
        mapCurrent.addLayer({
          id: GOVS_LINE,
          type: "line",
          source: GOVS_LINE,
          layout: { visibility: "visible" },
          paint: {
            "line-color": [
              'case', 
              ['boolean', ['feature-state', 'selected'], false], 'rgb(175, 35, 35)','rgba(0,0,0,0)'],
            "line-width": 2,            
          },
        });
      });      

      // Correct the layer order
      mapCorrectLayerOrder(mapCurrent, LAYER_ORDER_ARRAY);

  }, [mapLoaded]);
  return null;
}

export default GovLayer;

